import * as axios from 'axios'
import store from "@/store/index.js"
import { Toast } from '@nutui/nutui';
// Toast.loading("加载中！")
let service = axios.create({
	baseURL: "/",
	timeout: 10000
})

// 请求拦截 可在请求头中加入token等
service.interceptors.request.use(config => {
	// if (process.env.NODE_ENV != "development") {
		// 生产环境写死域名
		// 测试域名http://testwl.10cifang.com/
		// 正式域名http://app.wldancer.com/
		// if (config.url.indexOf("sys") != -1) {
		// 	config.baseURL = "http://test.10cifang.com/"
		// } else {
		// 	config.baseURL = store.state.huanj == 0 ? "http://testwl.10cifang.com/" : "http://app.wldancer.com/"
		// }
	// }
	let headers = {}
	if (store.state.token) {
		headers["Content-Type"] = 'application/x-www-form-urlencoded'
		headers["Authorization"] = store.state.token
		// config.headers.Authorization = store.state.token
		// config.headers["Content-Type"] = 'application/x-www-form-urlencoded'
	}
	config.headers = headers
	return config
}, error => {
	return Promise.reject(error)
})

// 响应拦截 对响应消息作初步的处理
service.interceptors.response.use(resp => {
	if (resp.data) {
		// Toast.hide()
		if (resp.data.code !== 200 && resp.data.code !== 1001 && resp.data.code !== 1002 && resp.data.code !== 404) {
			Toast.fail(resp.data.message);
		}
		return {
			code: resp.data.code,
			data: resp.data.data,
			msg: resp.data.message
		}
	} else {
		return resp
	}
}, error => {
	// Toast.hide()
	if (error.response) {
		switch (error.response.states) {
			case 400: {
				if (error.response && error.response.data && error.response.data.message) {
					Toast.fail(error.response.data.message);
				}
				break
			}
			default:
				Toast.fail("请求失败！");
				break
		}
	}
})

export default service
